var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBannerIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 13.5,
    fill: "#434652"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 36,
    fill: "#232327"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 12,
    width: 12,
    height: 12,
    rx: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 12,
    width: 12,
    height: 12,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 12,
    width: 12,
    height: 12,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 67.5L61.5 99",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 67.5L31.5 84.75L48.75 102",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 67.5L111.75 84.75L94.5 102",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBannerIcon3);
export default __webpack_public_path__ + "static/media/skills-bannerIcon_3.efdb410bbf33a1156686aefa8d013ea1.svg";
export { ForwardRef as ReactComponent };